import { AbstractControl, ValidationErrors, Validators } from '@angular/forms';
import { SpousalWaiverEntryFormGroup } from '../../../../../../../../forms/spousal-waiver-form-group';

export function spousalWaiverRequiredValidator(group: AbstractControl): ValidationErrors | null {
  const formGroup = group as SpousalWaiverEntryFormGroup;
  const { id, spousalDeclaration, spousalWaiverDateSigned, spousalWaiverEffectiveDate, spousalWaiverType } =
    formGroup.controls;

  const declarationValue = spousalDeclaration.value;
  const hasAnyValue =
    (Array.isArray(declarationValue) && declarationValue.length > 0) ||
    !!spousalWaiverDateSigned.value ||
    !!spousalWaiverEffectiveDate.value ||
    !!spousalWaiverType.value;

  const hasExistingId = !!id.value;

  for (const control of [spousalDeclaration, spousalWaiverDateSigned, spousalWaiverEffectiveDate, spousalWaiverType]) {
    const isDeclarationExempt = control === spousalDeclaration && hasExistingId;
    const shouldBeRequired = hasAnyValue && !isDeclarationExempt;
    const hasRequired = control.hasValidator(Validators.required);
    if (shouldBeRequired && !hasRequired) {
      control.addValidators(Validators.required);
      control.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    } else if (!shouldBeRequired && hasRequired) {
      control.removeValidators(Validators.required);
      control.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    }
  }

  return null;
}
